<template>
  <div class="f-image-preview mb-3 pt-3">
    <div v-if="loading" class="f-image-preview__spinner">
      <div class="spinner-border spinner-border-sm text-secondary" />
    </div>
    <div v-show="!loading" class="f-image-preview__wrap">
      <img
        v-if="src"
        :src="src"
        :alt="alt"
        class="w-100"
        style="max-height: 400px; object-fit: contain"
        @load="loading = false"
        @error="loading = false"
      >
      <button
        v-if="deletable"
        class="f-image-preview__delete"
        type="button"
        :disabled="deleting"
        @click="$emit('delete')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FImagePreview',
  props: {
    src: { type: String, default: null },
    alt: { type: String, default: '' },
    deletable: { type: Boolean, default: false },
    deleting: { type: Boolean, default: false }
  },
  data() {
    return { loading: !!this.src }
  },
  watch: {
    src(val) {
      this.loading = !!val
    }
  }
}
</script>

<style scoped>
.f-image-preview__spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
}
.f-image-preview__wrap {
  position: relative;
  display: inline-block;
  width: auto;
  max-width: 100%;
}
.f-image-preview__delete {
  position: absolute;
  top: 0;
  right: 0;
  width: 30px;
  height: 30px;
  padding: 0;
  border: none;
  background-color: transparent;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect x='0.5' y='0.5' width='29' height='29' rx='14.5' fill='white'/%3e%3cg clip-path='url(%23clip0)'%3e%3cpath d='M20.55 20.95C20.45 20.95 20.25 20.95 20.15 20.85L10.15 10.85C9.95 10.65 9.95 10.35 10.15 10.15C10.35 9.95 10.65 9.95 10.85 10.15L20.85 20.15C21.05 20.35 21.05 20.65 20.85 20.85C20.85 20.95 20.65 20.95 20.55 20.95Z' fill='%23A2A0A0'/%3e%3cpath d='M10.55 20.95C10.45 20.95 10.25 20.95 10.15 20.85C9.95 20.65 9.95 20.35 10.15 20.15L20.15 10.15C20.35 9.95 20.65 9.95 20.85 10.15C21.05 10.35 21.05 10.65 20.85 10.85L10.85 20.85C10.85 20.95 10.65 20.95 10.55 20.95Z' fill='%23A2A0A0'/%3e%3c/g%3e%3crect x='0.5' y='0.5' width='29' height='29' rx='14.5' stroke='%23A2A0A0'/%3e%3cdefs%3e%3cclipPath id='clip0'%3e%3crect width='11' height='11' fill='white' transform='translate(10 10)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e");
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
}
.f-image-preview__delete:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// src/components/FormFields/FImagePreview.vue